<template>
  <span
    v-if="resolved"
    class="equipe-chip"
    :style="{ background: resolved.hex, color: resolved.textColor, borderColor: resolved.mainColor }"
  >
    {{ resolved.label }}
  </span>
</template>

<script>
import { getEquipe } from '../lib/equipes'

export default {
  name: 'EquipeChip',
  props: {
    // Aceita string com value do enum ou null (Sem equipe).
    equipe: { type: String, default: null }
  },
  computed: {
    resolved() { return getEquipe(this.equipe) }
  }
}
</script>

<style scoped>
.equipe-chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: var(--text-xs);
  font-weight: 700;
  letter-spacing: 0.4px;
  border: 1px solid;
}
</style>
